export default class Usuario {

  constructor(
    IdUsuario = null,
    Descricao = '',
    Status = 'A',
    Email,
    IdPerfil,
    Perfil,
    IdColaborador,
    Colaborador,
    SenhaLogin
  ) {
    this.IdUsuario = IdUsuario;
    this.Descricao = Descricao;
    this.Status = Status;
    this.Email = Email;
    this.IdPerfil = IdPerfil;
    this.Perfil = Perfil;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
    this.SenhaLogin = SenhaLogin;
  }
  
}